//#region src/core/i18n/locales/hr.ts
var hr_default = {
	buttons: {
		play: "Pusti",
		pause: "Pauza",
		replay: "Ponovi",
		mute: "Prigušen",
		unmute: "Ne-prigušen"
	},
	seek: {
		forward: "Preskoči naprijed {seconds} sekundi",
		backward: "Preskoči unatrag {seconds} sekundi"
	},
	fullscreen: {
		enter: "Puni ekran",
		exit: "Izađi iz cijelog zaslona"
	},
	captions: {
		enable: "Uključi titlove",
		disable: "Isključi titlove"
	},
	pip: {
		enter: "Slika u slici",
		exit: "Izađi iz slike u slici"
	},
	live: {
		playing: "Reprodukcija uživo",
		seekToEdge: "Prijeđi na live",
		badge: "Uživo"
	},
	cast: {
		start: "Pokreni emitiranje",
		stop: "Zaustavi emitiranje",
		connecting: "Povezivanje"
	},
	airplay: {
		start: "Pokreni AirPlay",
		stop: "Zaustavi AirPlay"
	},
	slider: { seek: "Premotavanje" },
	time: {
		current: "Trenutno vrijeme",
		duration: "Vrijeme trajanja",
		remaining: "Preostalo vrijeme",
		elapsedSuffix: "{duration} proteklog vremena",
		durationSuffix: "{duration} trajanja",
		remainingSuffix: "Preostalo {duration}",
		showElapsed: "Prikaži proteklo vrijeme, {duration}.",
		showDuration: "Prikaži trajanje, {duration}.",
		showRemaining: "Prikaži preostalo vrijeme, {duration}.",
		toggleElapsed: "Prebacivanje između proteklog i preostalog vremena.",
		toggleDuration: "Prebacivanje između trajanja i preostalog vremena.",
		position: "{current} od {duration}",
		unknown: "Medijski sadržaj nije učitan, vrijeme nije poznato."
	},
	playback: { rate: "Stopa reprodukcije {rate}" },
	volume: {
		mutedValue: "{percent}, utišano",
		muted: "Utišano",
		label: "Glasnoća",
		value: "Glasnoća {value}"
	},
	status: {
		captionsOn: "Titlovi uključeni",
		captionsOff: "Titlovi isključeni",
		paused: "Pauzirano",
		playing: "Reproducira se",
		fullscreen: "Cijeli zaslon",
		pip: "Slika u slici",
		exitPip: "Izađi iz slike u slici",
		seekedTo: "Premotano na {time}"
	},
	container: { label: "Medijski reproduktor" },
	errors: {
		aborted: "Isključili ste reprodukciju videa.",
		network: "Video se prestao preuzimati zbog greške na mreži.",
		decode: "Reprodukcija videa je zaustavljenja zbog greške u formatu ili zbog verzije vašeg pretraživača.",
		source: "Video se ne može reproducirati zbog servera, greške u mreži ili je format ne podržan.",
		encrypted: "Medij je šifriran i nema ključeva za dešifriranje.",
		unplayable: "Reproduktor ne podržava ovaj medij.",
		title: "Nešto je pošlo po zlu.",
		unexpected: "Došlo je do pogreške. Pokušajte ponovo."
	},
	common: {
		empty: "",
		ok: "Zatvori"
	},
	menu: {
		settings: "Postavke",
		quality: "Kvaliteta",
		audio: "Zvuk",
		default: "Zadano",
		speed: "Brzina",
		captions: "Titlovi",
		playbackRate: "Brzina reprodukcije",
		back: "Natrag",
		off: "Isključeno",
		auto: "Automatski",
		autoWithLabel: "Automatski ({label})",
		subtitles: "Titlovi"
	}
};
//#endregion
export { hr_default as default };

//# sourceMappingURL=hr.js.map